import { Action } from '@ngrx/store';

// Get all venues
export const GET_ENTERTAINMENT_EVENT = '[Entertainment Event] Get Entertainment Event';
export const GET_ENTERTAINMENT_EVENT_SUCCESS = '[Entertainment Event] Get Entertainment Event Success';
export const GET_ENTERTAINMENT_EVENT_FAIL = '[Entertainment Event] Get Entertainment Event Fail';

export class GetEntertainmentEvent implements Action {
  readonly type = GET_ENTERTAINMENT_EVENT;
  constructor(public payload: any) {}
}

export class GetEntertainmentEventSuccess implements Action {
  readonly type = GET_ENTERTAINMENT_EVENT_SUCCESS;
  constructor(public payload: any) {}
}

export class GetEntertainmentEventFail implements Action {
  readonly type = GET_ENTERTAINMENT_EVENT_FAIL;
  constructor(public payload: any) {}
}

export type EntertainmentEventAction = GetEntertainmentEvent | GetEntertainmentEventSuccess | GetEntertainmentEventFail;
